import { Skeleton } from '@chakra-ui/react';
import React from 'react';

import { date as commonDate } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import {
  BorrowingBasePipelineSingleProgressBreakdownGQLType,
  StepStatusEnumGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { VerificationStatusIcon } from './VerificationIcons';
import { VerificationProgressTracker } from './VerificationProgressTracker';
import { VerificationsAccordion } from './VerificationsTemplate';
import { useGetCreditFacilityQuery } from 'packages/credit-facility/requests/requests.gql.generated';

export const VerificationCalculateAccordion: React.FC<{
  selectedCreditFacilityId: string;
  selectedReportingDate: Util.FullDateStr;
  isExpanded: boolean;
  overallStatus: StepStatusEnumGQLType;
  progressBreakdownStatus: BorrowingBasePipelineSingleProgressBreakdownGQLType[];
}> = ({
  selectedCreditFacilityId,
  selectedReportingDate,
  isExpanded,
  overallStatus,
  progressBreakdownStatus,
}) => {
  const {
    data: creditFacilityData,
    loading: creditFacilityLoading,
  } = useGetCreditFacilityQuery({
    variables: { creditFacilityId: selectedCreditFacilityId },
  });

  if (!creditFacilityData || creditFacilityLoading) {
    return (
      <Skeleton
        data-testid="loading-verification-calculate-accordian"
        height="600px"
      />
    );
  }
  const {
    creditFacility: { formattedSlug },
  } = creditFacilityData;

  const header = `Calculate ${commonDate.fullDateStrToSlashedDateStr(
    selectedReportingDate,
    commonDate.formatSlashedDateStr,
  )} Servicer Report for ${formattedSlug}`;

  return (
    <VerificationsAccordion
      header={header}
      icon={<VerificationStatusIcon status={overallStatus} />}
      isExpanded={isExpanded}
    >
      <VerificationProgressTracker
        progressBreakdown={progressBreakdownStatus}
      />
    </VerificationsAccordion>
  );
};
